import Vue from "vue";
import Sortable from 'sortablejs'
import Tools from "@includes/tools";

Vue.directive("sortable-data-table", {
    bind (el, binding, vnode) {
        const options = {
            animation: 150,
            onUpdate: function (event) {
                vnode.child.$emit('sorted', event)
            },
            handle: '.btn-sort'
        }
        Sortable.create(el.getElementsByTagName('tbody')[0], options)
    }
})

Vue.directive("uppercase", {
    update(el) {
        let input = el.querySelector('input');

        let sourceValue = input.value;
        const newValue = sourceValue.toUpperCase();

        if (sourceValue !== newValue) {
            input.value = newValue;
            input.dispatchEvent(new Event('input', { bubbles: true }));
        }
    },
})

Vue.directive("capitalize", {
    update(el) {
        let input = el.querySelector('input');

        let sourceValue = input.value;
        const newValue = Tools.capitaliserFirstLetter(sourceValue.toLowerCase());

        if (sourceValue !== newValue) {
            input.value = newValue;
            input.dispatchEvent(new Event('input', {bubbles: true}));
        }
    },
})

Vue.directive("limit-value", {
    inserted(el) {
        // On cible l'élément <input> interne du composant Vuetify (ex. v-text-field)
        const input = el.querySelector('input');
        if (!input) return;

        // Fonction de vérification / ajustement de la valeur saisie
        const checkBounds = () => {
            const val = input.value;
            if (val === '') return;  // laisser la saisie vide

            const numberVal = parseFloat(val);
            if (isNaN(numberVal)) return; // valeur non numérique

            // On récupère les bornes depuis les attributs du champ
            const minAttr = input.min;
            const maxAttr = input.max;
            if (minAttr === '' && maxAttr === '') return; // aucune borne définie

            // Si la valeur dépasse le max, on la remplace par le max
            if (maxAttr !== '' && numberVal > parseFloat(maxAttr)) {
                input.value = maxAttr;
                input.dispatchEvent(new Event('input', {bubbles: true}));
            }
            // De même, si la valeur est inférieure au min, on la remplace par le min
            else if (minAttr !== '' && numberVal < parseFloat(minAttr)) {
                input.value = minAttr;
                input.dispatchEvent(new Event('input', {bubbles: true}));
            }
        };

        // On écoute l'événement input (pour la saisie au clavier)
        input.addEventListener('input', checkBounds);
        // On écoute l'événement paste (pour le copier-coller)
        input.addEventListener('paste', () => {
            // On laisse le temps au collage de s'opérer, puis on vérifie
            setTimeout(checkBounds, 0);
        });
    }
})